import { ICarrier, ICarrierResponsePayload } from 'types'
import { carrierStatuses } from 'constants/carriers'

export const findStatus = (fmcsaInfo: ICarrierResponsePayload, carrierData: ICarrier) => {
  if (fmcsaInfo && fmcsaInfo.carrierApplication && fmcsaInfo.carrierApplication.state) {
    return carrierStatuses[fmcsaInfo.carrierApplication.state]
  }
  return carrierData.stateName
}
